import React from 'react';
import TopBar from '../components/TopBar';
import Footer from '../components/Footer';

const AuthenticatedLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-secondary flex flex-col">
      <TopBar />
      <main className="container mx-auto px-4 py-8 flex-grow">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default AuthenticatedLayout;
